// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    
    async getUser({ commit, state, rootState, rootGetters }, { id }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/users/${id}`, config);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    async getUserByToken({ commit, state, rootState, rootGetters }) {

        const access_token = rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/user/`, config);
            commit('updateCurrentUser', response.data)
            localStorage.setItem('userId', response.data.id)
            return response.data;
        } catch (error) {
            return error;
        }
    },


    async getUsers({ commit, state, rootState, rootGetters }, { id }) {
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;


            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/users`, config);

            // Возвращаем данные ответа
            return {
                status: response.status,
                data: response.data
            }
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async createUsers ({ commit, state, rootState, rootGetters  }, { name, email, password }) {

        const access_token = rootGetters.access_token;
        
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/users`,
                {
                    name: name,
                    email: email,
                    password: password,
                    role_id: 2
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            
            
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },

    async updateUsers ({ commit, state, rootState, rootGetters  }, { id, name, email, role_id }) {
         const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/users/${id}`,
                {
                    name: name,
                    email: email,
                    role_id: role_id
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );

            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },


    async updateUser ({ commit, state, rootState, rootGetters  }, { name, email, role_id }) {
        const access_token = rootGetters.access_token;

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/user/`,
                {
                    name: name,
                    email: email,
                    role_id: role_id
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    },


 


};
